module.exports = __webpack_public_path__ + "assets/media/user-member-lovel08.e3793d77.png";